var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8335 15.3534L14.4569 19.4832H17.2101L15.8335 15.3534ZM17.9435 21.6832H13.7236L12.9188 24.0978C12.7266 24.6741 12.1037 24.9856 11.5273 24.7935C10.951 24.6013 10.6395 23.9784 10.8316 23.4021L13.748 14.6531C13.748 14.6531 13.748 14.6531 13.748 14.6531C14.0472 13.7554 14.8873 13.1499 15.8335 13.1499C16.7797 13.1499 17.6199 13.7553 17.9191 14.6531C17.9191 14.6531 17.9191 14.6531 17.9191 14.6532L20.8354 23.4021C21.0275 23.9784 20.7161 24.6013 20.1397 24.7935C19.5634 24.9856 18.9404 24.6741 18.7483 24.0978L17.9435 21.6832ZM24.5419 13.1499C25.1494 13.1499 25.6419 13.6424 25.6419 14.2499V23.7499C25.6419 24.3574 25.1494 24.8499 24.5419 24.8499C23.9344 24.8499 23.4419 24.3574 23.4419 23.7499V14.2499C23.4419 13.6424 23.9344 13.1499 24.5419 13.1499Z",
    fill: "url(#paint0_linear_696_1965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33317 18.9998C6.33317 13.0287 6.33317 10.0432 8.18816 8.18816C10.0432 6.33317 13.0287 6.33317 18.9998 6.33317M6.33317 18.9998C6.33317 24.9709 6.33317 27.9566 8.18816 29.8115C10.0432 31.6665 13.0287 31.6665 18.9998 31.6665M6.33317 18.9998L3.1665 18.9998M18.9998 6.33317C24.9709 6.33317 27.9566 6.33317 29.8115 8.18816C31.6665 10.0432 31.6665 13.0287 31.6665 18.9998M18.9998 6.33317L18.9998 3.1665M31.6665 18.9998C31.6665 24.9709 31.6665 27.9566 29.8115 29.8115C27.9566 31.6665 24.9709 31.6665 18.9998 31.6665M31.6665 18.9998L34.8332 18.9998M18.9998 31.6665L18.9998 34.8332M12.6665 3.1665V6.33317M25.3332 3.1665V6.33317M12.6665 31.6665V34.8332M25.3332 31.6665V34.8332M34.8332 25.3332H31.6665M6.33317 12.6665H3.1665M6.33317 25.3332H3.1665M34.8332 12.6665H31.6665",
    stroke: "url(#paint1_linear_696_1965)",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_1965",
    x1: 8.50018,
    y1: 6,
    x2: 33.5002,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FF99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_696_1965",
    x1: 6.49982,
    y1: 4.99976,
    x2: 29.9998,
    y2: 32.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FF99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.a5238935e69c5b2b1b5c5583279e1636.svg";
export { ForwardRef as ReactComponent };